<template>
  <div>
    <a-modal
      width="600px"
      title="创建下载"
      v-model:visible="visible"
      :confirm-loading="confirmLoading"
    >
      <a-form ref="form" :model="form" :rules="rules" class="info-dialog-form">
        <a-form-item label="名称" name="createName">
          <a-input v-model:value="form.createName" autocomplete="off"></a-input>
        </a-form-item>
        <a-form-item label="描述" name="createDescription">
          <a-input
            v-model:value="form.createDescription"
            autocomplete="off"
          ></a-input>
        </a-form-item>
        <a-form-item label="原因" name="createNote">
          <a-input v-model:value="form.createNote" autocomplete="off"></a-input>
        </a-form-item>
        <a-form-item label="下载方式" name="downloadType">
          <a-select ref="select" v-model:value="form.type" style="width: 120px">
            <a-select-option value="zip">下载包</a-select-option>
            <a-select-option value="copy">导出至存储</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="form.type == 'copy'"
          label="导出位置"
          name="targetPath"
        >
          <path-choose ref="pc" @update="setPath"></path-choose>
          <a-input
            disabled
            v-model:value="form.targetPath"
            autocomplete="off"
          ></a-input>
          <a-button type="primary" class="mt10" @click="pathOpen"
            >选择路径</a-button
          >
          <!-- <a-button class="ml10" @click="pathChooseHandle(form,'targetPath','path', false)">选择目录</a-button> -->
        </a-form-item>
      </a-form>
      <template v-slot:footer>
        <a-button key="back" @click="handleCancel">取消</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="confirmLoading"
          @click="handleOk()"
          >创建</a-button
        >
      </template>
    </a-modal>
    <!-- <a-modal
      title="文件选择"
      v-model:visible="fileDialogVisible"
      z-index = 2
      width="700px">
      <div>
        <v-jstree v-if="fileDialogVisible && !multipleFlag" :data="filePaths" :async="loadFilePath" show-checkbox whole-row ></v-jstree>
        <v-jstree v-if="fileDialogVisible && multipleFlag" :data="filePaths" :async="loadFilePath" show-checkbox multiple whole-row></v-jstree>
      </div> 
      <span slot="footer" class="dialog-footer">
        <el-button @click="fileDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getChooseDir(fileTarget, fileKey)" :disabled="pathLoading">确 定</el-button>
      </span>


      <template v-slot:footer>
        <a-button key="back" @click="handleCancel">取消</a-button>
        <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">创建</a-button>
      </template>
    </a-modal> -->
  </div>
</template>
<script>
import { addPakage, creatPackageRecord } from "@/api/dataDownload";
import { mapState } from "vuex";
import PathChoose from "./pathChoose.vue";
//import VJstree from 'vue-jstree'
//import { mixins } from "@/mixin/index";
export default {
  // mixins:[mixins],
  // components:{
  //   VJstree
  // },
  components: {
    PathChoose,
  },
  props: {
    currentDataSet: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        datasetId: "",
        createName: "",
        createDescription: "",
        createNote: "",
        type: "zip",
        targetPath: "",
      },
      rules: {
        createName: [
          { required: true, message: "请填写下载包名称", trigger: "blur" },
        ],
        createNote: [
          { required: true, message: "请填写创建下载包原因", trigger: "blur" },
        ],
        targetPath: [
          { required: true, message: "目录不能为空", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    open() {
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
      });
    },
    pathOpen() {
      this.$refs.pc.open();
    },
    setPath(val) {
      this.form.targetPath = val;

      this.$forceUpdate();
    },
    handleOk() {
      if (this.form.type == "zip") {
        this.form.targetPath = "";
      }
      this.$refs.form.validate().then(() => {
        this.form.datasetId = this.currentDataSet.id;

        creatPackageRecord({
          ...this.form,
        })
          .then((res) => {
            this.$message.success(
              "下载数据包正在创建，请至“数据准备/数据下载”页面进行下载"
            );
            this.visible = false;
          })
          .catch((e) => {
            this.$message.error("创建失败");
          });

        // const addition = this.currentDataSet.addition.replace(/=/g, '%3D').replace(/&/g, '%26')
        // creatPackageRecord({
        //   addition,
        //   datasetId: this.currentDataSet.id,
        //   ...this.form,
        //   createUserId: this.userInfo.userId
        // }).then(res => {
        //   this.$message.success('下载数据包正在创建，请至“数据准备/数据下载”页面进行下载')
        //   this.visible = false
        // }).catch(e => {
        //   this.$message.error('创建失败')
        // })
      });
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>
